(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue2-org-tree", [], factory);
	else if(typeof exports === 'object')
		exports["vue2-org-tree"] = factory();
	else
		root["vue2-org-tree"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition